import Modal, { ModalClose } from '@acri-tools/react-tools/components/Modal/Modal';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { axiosErrorHandler, toast_request_error } from '@acri-tools/react-tools/utils/global';
import { API_URL } from '../../utils/config';
import { isAdmin } from '@acri-tools/react-tools/utils/_user_manager/login';
import request from '@acri-tools/react-tools/utils/request';
import React,{Component} from 'react';
import DataTable from '../DataTable/DataTable';

import ViewFile from '@acri-tools/react-tools/components/ViewFile/ViewFile';
import { create_toast } from '@acri-tools/react-tools/utils/toasts';
import UpdateDataMaintenance from '../UpdateDataMaintenance/UpdateDataMaintenance';

import './DataMaintenancesSearch.css';

interface Props{
    type: 'DCR'|'service_request'
    data: Array<any>
    reload_data: Function
}
interface State{
    update?: any

    description_open?: any
}

export default class DataMaintenancesSearch extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state = { };
    }
    render(){
        return (
            <div className="data-maintenance-search">
                {
                    this.state.update &&
                    <>
                        <Modal
                            className="medium"
                            opened={!!this.state.update}
                            close={()=>{ this.setState({ update: null }) }}
                        >
                            <div className="modal-title">
                                UPDATE DATA MAINTENANCE <ModalClose close={()=>{ this.setState({ update: null }) }}/>
                            </div>
                            <div className="modal-content">
                                <UpdateDataMaintenance
                                    data={this.state.update}
                                    onUpdate={()=>{
                                        this.setState({ update: null });
                                        this.props.reload_data();
                                        // this.fetch_data();
                                    }}
                                />
                            </div>
                        </Modal>
                    </>
                }

                {
                    this.state.description_open &&
                    <ViewFile
                        path={this.state.description_open?.data?.description}
                        modalProps={{ noAppend: true }}
                        opened={!!this.state.description_open}
                        close={()=>{ this.setState({ description_open: undefined }) }}
                        hide_creation_date hide_path
                    />
                }

                <DataTable
                    update_filter
                    filters={this.get_filters()}
                    headers={this.get_headers()}
                    field_output={this.get_field_outputs()}
                    data={this.props.data}
                    default_rows={50}
                    export
                    export_name={`${this.props.type}`}
                    // export_columns=
                    export_format={this.export_format}
                    operations={this.get_operations()}
                    sort_columns={{
                        'data_id': { filter: 'alphabetical' },
                        'original_dataset': { filter: 'alphabetical' },
                        'final_dataset': { filter: 'alphabetical' },
                        'change_applied': { filter: 'alphabetical' },
                        'mission': { filter: 'alphabetical' },
                        'title': { filter: 'alphabetical' },
                        'status': { filter: 'alphabetical' },
                        'repository_of_output_data': { filter: 'alphabetical' },
                        'request_date': { filter: 'date' },
                        'date_of_closure': { filter: 'date' },
                        'implemented_by': { filter: 'alphabetical' },
                    }}
                />
            </div>
        );
    }

    export_format = (row:any) =>{
        if(this.props.type === 'service_request'){
            return {
                "ID": row.data_id,
                "Original dataset": row.data?.original_dataset,
                "Final dataset": row.data?.final_dataset,
                "Change Applied": row.data?.change_applied,
            }
        }
        else{
            return {
                "ID": row.data_id,
                "Mission": row.data?.mission,
                "DCR Title": row.data?.title,
                "Status": row.data?.status,
                "Repository of output data": row.data?.repository_of_output_data,
                "Date of request": row.data?.request_date,
                "Date of closure": row.data?.date_of_closure,
                "Implemented by": row.data?.implemented_by,
            }
        }
    }

    get_operations = () =>{
        if(!isAdmin()) return undefined;
        return (row:any)=>(
            <div className="table-operations">
                <div 
                    className="custom-button inline small blue shadow inverted rounded icon-only alt tt"
                    onClick={()=>{ this.setState({ update: row }) }}
                >
                    <i className="fas fa-pen"/>
                    <div className="tt-tooltip">update</div>
                </div>
                <div 
                    className="custom-button inline small red shadow inverted rounded icon-only alt tt"
                    onClick={()=>{ this.delete(row); }}
                >
                    <i className="fas fa-times"/> <div className="tt-tooltip">delete</div>
                </div>
            </div>
        )
    }

    convert_date = (row:any, field: string) =>{
        let date:Date = row[field];
        if(!date) return null;
        if(typeof date === 'string') date = new Date(date);
        return `${date.getUTCDate().toString().padStart(2,'0')}/${(date.getUTCMonth() + 1).toString().padStart(2,'0')}/${date.getUTCFullYear()}`;
        // return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    }

    get_field_outputs = () =>{
        switch(this.props.type){
            case 'service_request': 
                return {
                    'change_applied': (row:any)=>(
                        <div className="data-maintenance-change-applied" dangerouslySetInnerHTML={{ __html: row?.data?.change_applied || ''  }}/>
                    )
                };
            case 'DCR': 
                return {
                    'request_date': (row:any) => this.convert_date(row, 'request_date'),
                    'date_of_closure': (row:any) => this.convert_date(row, 'date_of_closure'),
                    'status': (row:any)=>(
                        <div className={`dcr-status ${row.status}`}>
                            { row.status || "none" }
                        </div>
                    ),
                    'description': (row:any)=>(
                        <div className="data-maintenance-operations">
                            { 
                                !row.description ? undefined :
                                <div 
                                    className="custom-button inline small blue shadow rounded icon-only tt"
                                    onClick={()=>{
                                        console.debug("opening row", row);
                                        this.setState({ description_open: row })
                                    }}
                                >
                                    <i className="fas fa-file"/> <div className="tt-tooltip"> view file </div>
                                </div>
                            }
                        </div>
                    )
                }
            default: return undefined;
        }
    }


    get_headers = () =>{
        let common = [
            { label: <><i className="fas fa-id-card"/> ID</>, key:'data_id' },
        ]
        switch(this.props.type){
            case 'service_request': 
                return [
                    ...common,
                    { label: <><i className="fas fa-satellite"/> Original dataset</>, key:'original_dataset' },
                    { label: <><i className="fas fa-satellite"/> Final dataset</>, key:'final_dataset' },
                    { label: <><i className="fas fa-font"/> Change applied</>, key:'change_applied' },
                ]
            case 'DCR': 
                return [
                    ...common,
                    { label: <><i className="fas fa-satellite"/> Mission</>, key:'mission' },
                    { label: <><i className="fas fa-heading"/> DCR Title</>, key:'title' },
                    { label: <><i className="fas fa-asterisk"/> Status</>, key:'status' },
                    { label: <><i className="fas fa-folder"/> Repository of output data</>, key:'repository_of_output_data' },
                    { label: <><i className="fas fa-calendar"/> Date of request</>, key:'request_date' },
                    { label: <><i className="fas fa-calendar-alt"/> Date of closure</>, key:'date_of_closure' },
                    { label: <><i className="fas fa-users"/> Implemented by</>, key:'implemented_by' },
                    { label: <><i className="fas fa-font"/> Description</>, key:'description' },
                ]
        }
    }

    get_filters = () =>{
        switch(this.props.type){
            case 'service_request': 
                return undefined
                return [
                    { label: <>Final dataset</>, key:'final_dataset' },
                ]
            case 'DCR': 
                // return undefined
                return [
                    { label: <><i className="fas fa-satellite"/> Mission</>, key:'mission' },
                    { label: <><i className="fas fa-asterisk"/> Status</>, key:'status', null_value: 'none' },
                ]
        }
    }


    delete = async(row:any) =>{
        if(window.confirm(`Are you sure you want to remove ${row.data_id} ?`)){
            row.running_operation = true;
            this.forceUpdate();
            try{
                let res = await request(`${API_URL}/api/v1/data_maintenances/${row.id}`,{
                    method:'delete'
                })

                // let data = this.state.data;
                // data?.splice(data?.indexOf(row), 1);
                // this.setState({ data });

                this.props.reload_data();

                create_toast({ type: 'success', message: `Successfully removed data maintenance ${row.data_id}` });
            }
            catch(e:any){
                axiosErrorHandler( e, { 
                    functionName: 'delete'
                })
                toast_request_error(e);
            }
            finally{
                delete row.running_operation;
                this.forceUpdate();
            }
            
        }
    }
};

